import PropTypes from 'prop-types';

export const sltAmountDetailsType = PropTypes.shape({
  accountId: PropTypes.string,
  componentId: PropTypes.string,
  sltTaxAmount: PropTypes.number,
  accountDescription: PropTypes.string,
  sourceSystemId: PropTypes.string,
});
